import { ClipboardCheck, Package, ArrowRight, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
const SupportOptions = () => {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.05
  });
  return <section id="support-section" className="py-8 lg:py-10 bg-muted/30">
      <div className="container-custom" ref={ref}>
        <div className={cn("text-center mb-10 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Want More <span className="text-gradient">Support?</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Not ready to go fully DIY? We offer professional support options.
          </p>
        </div>

        <div className={cn("grid md:grid-cols-2 gap-8 max-w-4xl mx-auto stagger-children", isVisible && "visible")}>
          {/* Packet Review */}
          <Card className="flex flex-col h-full border-primary/30 hover:shadow-custom-md transition-all duration-300 hover:-translate-y-1 group">
            <CardHeader className="pb-4">
              <div className="flex items-center justify-between mb-2">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary/20 group-hover:scale-105 transition-all duration-300">
                  <ClipboardCheck className="w-6 h-6 text-primary" />
                </div>
                <Badge variant="outline" className="text-primary border-primary animate-pulse-soft">
                  Popular
                </Badge>
              </div>
              <CardTitle className="text-xl">Packet Review Service</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col flex-grow">
              <p className="text-muted-foreground mb-4">
                I want to send my own disputes, but I want a professional to review
                my paperwork first.
              </p>

              <ul className="text-sm text-foreground space-y-2 mb-6">
                {["Round 1 plan (1-3 items per bureau)", "Letter review and suggested edits", "Document checklist per item", "Assembly and mailing instructions"].map((item, idx) => <li key={idx} className="flex items-start gap-2 group/item">
                    <span className="text-primary group-hover/item:scale-125 transition-transform">•</span>
                    {item}
                  </li>)}
              </ul>

              <div className="mt-auto">
                <div className="mb-4">
                  <p className="text-2xl font-bold text-primary number-highlight">From $149</p>
                </div>

                <div className="space-y-2">
                  <Button asChild className="w-full group/btn">
                    <Link to="/packet-review">
                      Start Packet Review
                      <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                    </Link>
                  </Button>
                  <Button variant="ghost" size="sm" className="w-full text-muted-foreground hover:text-primary" onClick={() => document.querySelector("#templates-section")?.scrollIntoView({
                  behavior: "smooth"
                })}>
                    <FileText className="w-4 h-4 mr-2" />
                    Get templates first
                  </Button>
                </div>

                <p className="text-xs text-muted-foreground mt-4 italic">
                  Note: Requires dispute templates to review
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Done-For-You */}
          <Card className="flex flex-col h-full hover:shadow-custom-md transition-all duration-300 hover:-translate-y-1 group">
            <CardHeader className="pb-4">
              <div className="flex items-center justify-between mb-2">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary/20 group-hover:scale-105 transition-all duration-300">
                  <Package className="w-6 h-6 text-primary" />
                </div>
                <Badge variant="secondary">Premium</Badge>
              </div>
              <CardTitle className="text-xl">Done-For-You Processing</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col flex-grow">
              <p className="text-muted-foreground mb-4">
                I want the packet prepared for me — just tell me what to sign and
                mail.
              </p>

              <ul className="text-sm text-foreground space-y-2 mb-6">
                {["Profile review and Round 1 plan", "Dispute letters prepared for you", "Packet organized and shipped to you", "Ready to sign and mail"].map((item, idx) => <li key={idx} className="flex items-start gap-2 group/item">
                    <span className="text-primary group-hover/item:scale-125 transition-transform">•</span>
                    {item}
                  </li>)}
              </ul>

              <div className="pt-0 mt-0">
                <div className="mb-4">
                  <p className="text-2xl font-bold text-primary number-highlight">From $750</p>
                </div>

                <Button asChild className="w-full group/btn">
                  <Link to="/done-for-you">
                    Schedule a Call
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        <p className={cn("text-center text-xs text-muted-foreground mt-8 max-w-3xl mx-auto transition-all duration-700 delay-300", isVisible ? "opacity-100" : "opacity-0")}>
          No outcome guarantees. Results vary. We assist with preparing disputes
          for information you believe may be inaccurate, incomplete, or
          unverifiable.
        </p>
      </div>
    </section>;
};
export default SupportOptions;